import React from "react";
import "../css/my style2.css";


export default function Signupbuttonlight() {
   
    return(
        <button className="nav-button">Signup</button>
    )
}